module.exports = __webpack_public_path__ + "img/register.41432d04.jpg";